import React, { useEffect, useState } from 'react';
import { ControlProps, OwnPropsOfEnum } from '@jsonforms/core';
import { Radio, RadioChangeEvent } from 'antd';

type RadioGroupControlProps = ControlProps & OwnPropsOfEnum;

export const RadioGroupControl: React.FC<RadioGroupControlProps> = ({
  label,
  required,
  options,
  data,
  path,
  handleChange,
  uischema,
}) => {
  const [value, setValue] = useState(data ?? null);

  // `stacked` variant: heading on top, options on the next row (vs the default
  // label-left layout). `variant` may gain other values later.
  const stacked = uischema?.options?.variant === 'stacked';

  const handleRadioChange = (e: RadioChangeEvent) => {
    const newValue = e.target.value;
    setValue(newValue);
    handleChange(path, newValue);
  };

  useEffect(() => {
    setValue(data ?? null);
  }, [data]);

  return (
    <div
      className={
        stacked
          ? 'flex w-full flex-col border-b border-brightGray py-4 pl-1.5'
          : 'flex w-full justify-between border-b border-brightGray py-4 pl-1.5'
      }
    >
      <p
        className={
          stacked
            ? 'pb-2 text-1424 font-semibold'
            : 'min-w-[48%] pr-4 pt-2 text-1424 font-semibold'
        }
      >
        {label}
        <span className='text-redOrange'>{required && ' *'}</span>
      </p>

      <Radio.Group
        value={value}
        onChange={handleRadioChange}
        className={stacked ? 'flex flex-row gap-x-10' : 'flex flex-col'}
      >
        {options?.map(option => (
          <Radio value={option.value} key={option.label} className='my-0.5'>
            {option.label}
          </Radio>
        ))}
      </Radio.Group>
    </div>
  );
};
